import { BaseApiV2, Methods } from "@newview/infrastructure";

export abstract class NVBasicBaseApi extends BaseApiV2 {
    public get ProxyName(): any {
        return 'NVBasicBaseApi';
    }
}
